import { Helpers } from "infrastructure/app.helpers";
import { IExtraOptionPrototype } from "infrastructure/interfaces/IExtraMenuOption";
import {NotifyService} from "infrastructure/services/notifyService";
import moment from "moment";

export default {
    title: "Пролонгировать в 3.0",
    action(context) {
        const notifyService = context.di<NotifyService>("notifyService");
        if (!context.Contract.isSigned()) {
            notifyService.errorMessage(
                null,
                `Договор не может быть продлен, так как его статус — ${context.Contract.StatusName}. Продление возможно только для оформленных договоров.`,
            );
            return;
        }
        if (
            ("IsPaid" in context.Contract && !(context.Contract["IsPaid"])) ||
            ("IsPayed" in context.Contract && !(context.Contract["IsPayed"]))
        ) {
            notifyService.errorMessage(
                null,
                "Продление невозможно: текущий договор не оплачен.",
            );
            return;
        }
        const now = moment().startOf("day");
        const dayTo = moment(context.Contract["ContractTo"]);
        const daysBeforeEnd = moment(dayTo).subtract(60, "day");
        const daysAfterEnd = moment(dayTo).add(30, "day");

        if (now < dayTo && now < daysBeforeEnd) {
            notifyService.errorMessage(
                null,
                `Продление договора возможно не ранее, чем за 60 дней до окончания его действия. Дата окончания текущего договора: ${dayTo.format("DD.MM.YYYY")}. Попробуйте позже.`,
            );
            return;
        }
        if (now > dayTo && now > daysAfterEnd) {
            notifyService.errorMessage(
                null,
                `Продление договора возможно не позднее 30 дней после окончания договора. Дата окончания текущего договора: ${dayTo.format("DD.MM.YYYY")}. Оформите новый договор.`,
            );
            return;
        }

        window.parent.postMessage({
            type: "PROLONGATE",
            value: { product: context.product.code, contractGuid: context.Contract["Guid"], contractId: context.Contract["Id"] },
        }, "*");
    },
    disabled(context) {
        const helpers = context.di<Helpers>("helpers");
        if (!helpers.isEmbedMode()) {
            return true;
        }

        return !(context.Contract && context.Contract["Id"]);
    },
    icon: "fa-thumbs-up",
} as IExtraOptionPrototype;
